import request from '@h3/request';
import { H3 } from '@h3/types';

export function loadFrequentlyApps() {
    return request<H3.Http.Response.H3Response<Array<H3.Preference.Request.IFrequentlyAppItem>>>(
        '/v1/userfrequentlyapp/list',
        {
            method: H3.Http.MethodType.GET,
        },
    );
}

export function updateFrequentlyApps(data: H3.Preference.Request.IFrequentlyAppItem[]) {
    return request<H3.Http.Response.H3Response>('/v1/userfrequentlyapp/save', {
        method: H3.Http.MethodType.POST,
        data: {
            frequentlyApps: data,
        },
    });
}
